import React from "react";

import { makeStyles } from "@material-ui/core/styles";
import Grid from "@material-ui/core/Grid";
import Button from "@material-ui/core/Button";

import ContactDetailContainer from "./ContactDetailContainer";
import PropTypes from "prop-types";
import { useTranslation } from "react-i18next";
import { useNotifyContext } from "components/Notify";

const useStyles = makeStyles((theme) => ({
  button: {
    textTransform: "capitalize",
  },
  actionColumn: {
    "& button": {
      margin: theme.spacing(1),
      marginLeft: theme.spacing(0),
    },
  },
  tableStyle: {
    "& .MuiGrid-item": {
      borderBottom: "1px solid gray",
    },
  },
  inputStyle: {
    marginTop: theme.spacing(1),
  },
}));

const ShopContact = (props) => {
  const { t } = useTranslation();
  const { contacts, setContacts, renderOnly } = props;
  const classes = useStyles();
  const setNotify = useNotifyContext();

  const addNewContact = () => {
    const contactsWithConfirmedFalse = contacts.filter(
      (contact) => contact.confirmed === false
    );
    if (contactsWithConfirmedFalse.length > 0) {
      setNotify({
        isOpen: true,
        message:
          "Please confirm the unconfirmed changes before adding new contact.",
        type: "error",
      });
      return;
    }

    const joinedContact = contacts.concat({
      contact_number: "",
      mode: "",
      active: false,
      confirmed: false,
    });
    setContacts(joinedContact);
  };

  return renderOnly ? (
    <Grid container spacing={2}>
      <Grid item container direction="row" spacing={1} xs={12}>
        <Grid
          item
          container
          direction="row"
          spacing={2}
          xs={12}
          className={classes.tableStyle}
        >
          <Grid item lg={4}>
            {t("Contact Number")} <span style={{ color: "red" }}>*</span>
          </Grid>
          <Grid item lg={4}>
            <span>
              {t("Mode")} <span style={{ color: "red" }}>*</span>
            </span>
          </Grid>
          <Grid item lg={4}>
            <span>{t("Status")}</span>
          </Grid>
        </Grid>
        {contacts.map((data) => {
          return (
            <ContactDetailContainer
              key={data.contact_number}
              data={data}
              contacts={contacts}
              setContacts={setContacts}
              classes={classes}
              renderOnly={renderOnly}
            />
          );
        })}
      </Grid>
    </Grid>
  ) : (
    <Grid container spacing={2}>
      <Grid item xs={12}>
        <Button
          variant="contained"
          onClick={addNewContact}
          color="primary"
          className={classes.button}
        >
          {t("Add New")}
        </Button>
      </Grid>

      <Grid item container direction="row" spacing={1} xs={12}>
        <Grid
          item
          container
          direction="row"
          spacing={2}
          xs={12}
          className={classes.tableStyle}
        >
          <Grid item lg={3}>
            {t("Contact Number")} <span style={{ color: "red" }}>*</span>
          </Grid>
          <Grid item lg={3}>
            <span>
              {t("Mode")} <span style={{ color: "red" }}>*</span>
            </span>
          </Grid>
          <Grid item lg={3}>
            <span>{t("Status")}</span>
          </Grid>
          <Grid item lg={3}>
            <span>{t("Action")}</span>
          </Grid>
        </Grid>
        {contacts.map((data) => {
          return (
            <ContactDetailContainer
              key={data.contact_number}
              data={data}
              contacts={contacts}
              setContacts={setContacts}
              classes={classes}
            />
          );
        })}
      </Grid>
    </Grid>
  );
};
ShopContact.propTypes = {
  contacts: PropTypes.array,
  setContacts: PropTypes.func,
  submitContactState: PropTypes.array,
  setSubmitContactState: PropTypes.func,
  renderOnly: PropTypes.bool,
};

export default ShopContact;
